import React, { useState, useEffect } from "react";
import { LocalizationProvider, DesktopTimePicker } from "@mui/x-date-pickers";
import { AdapterMomentJalaali } from "@mui/x-date-pickers/AdapterMomentJalaali";
import moment from "moment-jalaali";
import { TextField } from "@mui/material";

moment.loadPersian({ usePersianDigits: false });

const PersianTimePicker = ({ value, label = "زمان", onChange }) => {
  const [selectedTime, setSelectedTime] = useState(
    value ? moment(value, "HH:mm") : null
  );

  // Update selectedTime when value prop changes
  useEffect(() => {
    if (value) {
      setSelectedTime(moment(value, "HH:mm"));
    }
  }, [value]);

  const handleTimeChange = (newValue) => {
    setSelectedTime(newValue);
    if (onChange) {
      onChange(newValue ? newValue.format("HH:mm") : null);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterMomentJalaali} adapterLocale="fa" >
      <DesktopTimePicker
        className="w-100 persian-time-picker"
        label={label}
        views={["hours", "minutes"]}
        value={selectedTime}
        onChange={handleTimeChange}
        renderInput={(params) => (
          <TextField
            {...params}
            sx={{
              "& .MuiInputBase-root": {
                height: "40px", // Adjust input base height
              },
              "& .MuiInputLabel-root": {
                fontSize: "1rem", // Change font size for label
                color: "red", // Change color for label
                fontWeight: "bold", // Change font weight for label
                "&.Mui-focused": {
                  color: "green", // Change color for label when focused
                  fontSize: "1.2rem", // Change font size for label when focused
                },
              },
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default PersianTimePicker;
